import React from 'react'
import { makeStyles } from '@mui/styles'
import './styles.css'

const GradientButton = (props) => {

    const classes = useStyles()

    const {  children } = props

    return(

        <button
            className = "btn-gradient"
            // className = {classes.btnGradient}
            {...props}
        >
            {children}
        </button>

    )

}

const useStyles = makeStyles(() => ({
    btnGradient: () => ({
        padding: '8px 24px',
        borderRadius: '40px',
        background: 'linear-gradient(68deg, #09D785 0.58%, #098CAF 99.42%)',
        boxShadow: '0px 4px 6px 0px rgba(0, 0, 0, 0.40)',

        color: '#fff',
        textAlign: 'center',
        fontFamily: 'Manrope',
        fontSize: '20px',
        fontStyle: 'normal',
        fontWeight: 700,

        cursor: 'pointer',
        transition: 'all',
        '&:hover': {
			transform: 'scale(1.1)',
        },
    })
}))

export default GradientButton